import {
  FETCH_ESTIMATIONS_START,
  FETCH_ESTIMATIONS_SUCCESS,
  FETCH_ESTIMATIONS_ERROR,
  DELETE_ESTIMATION_START,
  DELETE_ESTIMATION_SUCCESS,
  DELETE_ESTIMATION_ERROR,
} from "./estimations.types"

// Emails actions
export const fetchEstimationsStart = () => ({
  type: FETCH_ESTIMATIONS_START,
})
export const fetchEstimationsSuccess = (data) => ({
  type: FETCH_ESTIMATIONS_SUCCESS,
  payload: data,
})
export const fetchEstimationsError = (error) => ({
  type: FETCH_ESTIMATIONS_ERROR,
  payload: error,
})
export const deleteEstimationStart = (id) => ({
  type: DELETE_ESTIMATION_START,
  payload: id,
})
export const deleteEstimationSuccess = () => ({
  type: DELETE_ESTIMATION_SUCCESS,
})
export const deleteEstimationError = (error) => ({
  type: DELETE_ESTIMATION_ERROR,
  payload: error,
})
